module.exports = __webpack_public_path__ + "static/media/notfilled.a54c8269.svg";